import { useEffect, type PropsWithChildren, type ReactNode } from "react";
import Sidebar from "@/components/Sidebar";
import { Provider } from "@/components/ui/provider";
import { Flex, Box } from "@chakra-ui/react";
import { Head, usePage } from "@inertiajs/react";
import InertiaSharedProps from "@/types/inertia";
import { usePostHog } from "posthog-js/react";

const AppLayout = ({ children }: PropsWithChildren): ReactNode => {
  const { current_user } = usePage<InertiaSharedProps>().props;
  const posthog = usePostHog();

  useEffect(() => {
    if (current_user) {
      posthog?.identify(current_user.id.toString(), {
        email: current_user.email,
        first_name: current_user.first_name,
        last_name: current_user.last_name,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posthog, current_user?.id]);

  return (
    <Provider forcedTheme="light">
      <Head title="Muro" />
      <Flex minH="100vh">
        <Sidebar />
        <Box as="main" flex="1" bg="primary-subtle" p={6}>
          {children}
        </Box>
      </Flex>
    </Provider>
  );
};

export default AppLayout;
